import { ArrowUpSmall as ArrowUpSmall_kojaro } from './ArrowUpSmall.kojaro';
import { ArrowUpSmall as ArrowUpSmall_phosphor } from './ArrowUpSmall.phosphor';
import { ArrowUpSmall as ArrowUpSmall_zoomg } from './ArrowUpSmall.zoomg';
import { ArrowUpSmall as ArrowUpSmall_zoomit } from './ArrowUpSmall.zoomit';

const IconRenderer = () => {
  switch (process.env.NEXT_PUBLIC_ICON_SYSTEM) {
    case 'kojaro':
      return ArrowUpSmall_kojaro;

    case 'zoomg':
      return ArrowUpSmall_zoomg;

    case 'phosphor':
      return ArrowUpSmall_phosphor;

    default:
      return ArrowUpSmall_zoomit;
  }
};

export const ArrowUpSmall = IconRenderer();
